export interface Step {
	image: {
		[key: string]: string;
	};
	key: "intro" | "privacy" | "core-values" | "perfect-day";
	group?: number;
}

interface Group {
	current: number;
	count: number;
	groupStart: number;
	groupEnd: number;
}

export function getCarouselGroup(steps: Step[], scrollProgress: number): Group | undefined {
	const currentStepIndex = Math.round(scrollProgress);
	const currentStep = steps[currentStepIndex];

	if (!currentStep.group) {
		return undefined;
	}

	const firstStepIndex = steps.findIndex((step) => step.group === currentStep.group);
	const count = steps.filter((step) => step.group === currentStep.group).length;
	const lastStepIndex = firstStepIndex + count;

	return {
		current: Math.max(0, Math.min(scrollProgress - firstStepIndex, lastStepIndex - firstStepIndex)),
		count,
		groupStart: firstStepIndex,
		groupEnd: lastStepIndex,
	};
}
